import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createExpense } from "api/expense.api";
import {
  invalidateExpenseSide,
  invalidateVendorSide,
} from "lib/cacheInvalidation";

export const useCreateExpense = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createExpense,
    onSuccess: () => {
      invalidateExpenseSide(queryClient);
      invalidateVendorSide(queryClient); // a bill/expense changes the vendor's payable
    },
  });
};
